import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Pagination } from 'hljd'
import Store from '../store'
import Style from './style.module.less'

@observer
export default class extends Component {
  render() {
    const { conList, paginationTest } = Store

    return (
      <div className={Style.box} style={{ zIndex: 1000 }}>
        <div className={Style.modalBox}>
          <div className={Style.con}>
            {conList.map(item => (
              <div className={Style.conBox} key={item.id}>
                <dl>
                  <dt>
                    <img src={item.cover_path + '?imageView2/1/w/156/h/99'} />
                  </dt>
                  <dd>
                    <h3>{item.title}</h3>
                    <p>
                      <em>￥{item.actual_price}</em>
                      <i>￥{item.market_price}</i>
                    </p>
                  </dd>
                </dl>
                <img
                  onClick={Store.changeCheckedVal(item.id, 0)}
                  style={{
                    display:
                      Store.is_checked && item.id == Store.checkedVal
                        ? 'none'
                        : 'inline-block'
                  }}
                  className={Style.isCheck}
                  src="http://qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png"
                />
                <img
                  onClick={Store.changeCheckedVal(item.id, 1)}
                  style={{
                    display:
                      Store.is_checked && item.id == Store.checkedVal
                        ? 'inline-block'
                        : 'none'
                  }}
                  className={Style.isCheck}
                  src="http://qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png"
                />
              </div>
            ))}
          </div>
          <div className={Style.paginationTest}>
            <Pagination
              size="small"
              current={paginationTest.current}
              onChange={Store.onChange}
              pageSize={6}
              total={paginationTest.total}
            />
          </div>

          <p className={Style.btnBottom}>
            <a onClick={Store.okCon}>设为关联套餐</a>
            <a onClick={Store.cancelCon}>取消</a>
          </p>
        </div>
      </div>
    )
  }
}
